module.exports = __webpack_public_path__ + "static/media/ershoucheyewuliucheng.1b5f7c96.png";